var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.10074,
    cy: 17.2991,
    rx: 0.700354,
    ry: 0.700355,
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.10091,
    cy: 0.700872,
    rx: 0.700355,
    ry: 0.700354,
    transform: "rotate(180 9.10091 0.700872)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.26285,
    cy: 16.8919,
    r: 0.700354,
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.9393,
    cy: 1.11019,
    r: 0.700354,
    transform: "rotate(-180 16.9393 1.11019)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.87516,
    cy: 17.2991,
    rx: 0.700355,
    ry: 0.700354,
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3265,
    cy: 0.700872,
    rx: 0.700354,
    ry: 0.700354,
    transform: "rotate(180 14.3265 0.700872)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.48795,
    cy: 17.2991,
    rx: 0.700354,
    ry: 0.700355,
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7137,
    cy: 0.700872,
    rx: 0.700354,
    ry: 0.700354,
    transform: "rotate(180 11.7137 0.700872)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700355,
    transform: "matrix(-1 0 0 1 16.9393 16.8898)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 1.26237 1.11019)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700355,
    transform: "matrix(-1 0 0 1 14.3265 17.2991)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 3.87516 0.700872)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 0.841468 3.74063)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 17.3605 3.73965)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 0.841468 6.37107)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 17.3605 6.37009)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 0.841468 9.00152)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 17.3605 9.00053)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700355,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 0.841468 11.632)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700355,
    transform: "matrix(1 0 0 -1 17.3605 11.631)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 0.841467 14.2624)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 17.3605 14.2614)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700355,
    transform: "matrix(-1 0 0 1 11.7142 17.2991)",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.700354,
    ry: 0.700354,
    transform: "matrix(1 0 0 -1 6.48795 0.700872)",
    fill: "#677C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18.1411) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.6218dc515e9f5bd5fc18b0367d4a9d70.svg";
export { ForwardRef as ReactComponent };